import React from "react";
import PropTypes from "prop-types";
import "./LoadingAnime.css";
const LoadingAnime = ({
  numBoxes = 8,
  boxHeight = "12rem",
  gridColumns = "grid grid-cols-1 sm:grid-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-4 ",
  bgColor = "bg-gray-50",
  mainBoxWidth = "80vw",
  useShadow = true,
  innerBoxes = [
    {
      width: "3rem",
      height: "3rem",
      color: "bg-gray-400",
      shape: "circle",
      top: "0rem",
      left: "0.3rem",
    },
    {
      width: "50%",
      height: "12%",
      color: "bg-gray-400",
      shape: "rectangle",
      top: "3.5rem",
      left: "0.3rem",
    },
    {
      width: "30%",
      height: "37%",
      color: "bg-gray-400",
      shape: "rectangle",
      bottom: "0.8rem",
      left: "0.3rem",
    },
    {
      width: "40%",
      height: "15%",
      color: "bg-gray-400",
      shape: "rectangle",
      bottom: "0.8rem",
      right: "1rem",
    },
  ],
  page,
}) => {
  return (
    <div
      className={`mainbox ${
        page === "applicants" || page === "JobApplicants" || page === "basicMd"
          ? "p-0"
          : "p-5"
      }  ${page === "basic" ? "mt-10" : ""} ${
        page === "basicMd" ? "bg-gray-50" : ""
      } 
       ${page === "learningTab" ? "h-[60vh]" : ""}
       `}
      style={{
        width:
          page === "history" && window.innerWidth < 640
            ? "100%"
            : page === "cards" && window.innerWidth < 640
            ? "fit-content"
            : page === "applicants"
            ? "5rem"
            : page === "JobApplicants"
            ? "100%"
            : page === "resumescore"
            ? "100%"
            : page === "reportScreen"
            ? "24vw"
            : page === "reportScreenright"
            ? "100%"
            : page === "JobInternship"
            ? "100%"
            : page === "learningTab"
            ? "100%"
            : page === "profiles"
            ? "100%"
            : page === "basicMd"
            ? "100%"
            : mainBoxWidth, // Otherwise, use the default mainBoxWidth
      }}
    >
      <div
        className={`${
          page === "cards" || page === "Job-mid"
            ? "flex items-center justify-center gap-2 min-w-fit"
            : `loading-box grid  ${
                page === "profiles" ? "profiles-grid" : gridColumns
              } gap-y-[1rem] gap-x-[1rem] ${
                page == "profiles" ? "w-full" : ""
              } ${page === "viewall" ? "gap-y-[1.5rem] " : ""} ${
                page === "JobApplicants" ? "gap-y-[1rem] " : ""
              }  ${page === "learningTab" ? "w-full h-[100%]" : ""} ${
                page === "basicMd" ? "p-0" : "p-4"
              } `
        }`}
      >
        {Array.from({ length: numBoxes }).map((_, index) => (
          <div
            key={index}
            className={` ${bgColor} rounded-xl box-border p-5 animate-pulse ${
              useShadow ? "shadow-lg shadow-gray-200" : ""
            } ${page === "cards" ? "w-[285px]" : ""} ${
              page === "reportScreenright" ? "p-0" : ""
            } ${page === "Job-mid" ? "w-[147px]" : ""} `}
            style={{
              height:
                page === "learningTab" && window.innerWidth < 1000
                  ? "100%"
                  : boxHeight,
            }}
            // Only height is controlled by inline styles
          >
            {/* Flexbox container to position multiple inner boxes */}
            <div className="flex justify-start items-center h-full relative">
              {innerBoxes.map((innerBox, idx) => (
                <div
                  key={idx}
                  className={`bg-gray-200 ${
                    innerBox.shape === "circle" ? "rounded-full" : "rounded-md"
                  } max-md:${innerBox.WidthMd} max-md:${
                    innerBox.heigthMd
                  } max-md:${innerBox.display}`}
                  style={{
                    width: innerBox.width,
                    height: innerBox.height,
                    position: "absolute",
                    top: innerBox.top,
                    left: innerBox.left,
                    right: innerBox.right,
                    bottom: innerBox.bottom,
                    display: innerBox.display || "block",
                  }}
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Prop validation to ensure correct prop types
LoadingAnime.propTypes = {
  numBoxes: PropTypes.number,
  boxHeight: PropTypes.string,
  gridColumns: PropTypes.string,
  bgColor: PropTypes.string,
  mainBoxWidth: PropTypes.string,
  useShadow: PropTypes.bool, // New prop for conditional shadow
  innerBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
      color: PropTypes.string,
      shape: PropTypes.oneOf(["circle", "rectangle"]),
      top: PropTypes.string,
      left: PropTypes.string,
      bottom: PropTypes.string,
      right: PropTypes.string,
      display: PropTypes.string,
      WidthMd: PropTypes.string,
      heigthMd: PropTypes.string,
    })
  ),
};

export default LoadingAnime;
